import type { ReactNode } from "react";

import { FEATURE_FLAGS, useFeatureFlag } from "@/lib/posthog";

interface PMModuleGateProps {
  /** Rendered when the `PM-Module` flag is on (default). */
  children: ReactNode;
  /** Rendered when the flag is explicitly turned off in PostHog. Defaults to nothing. */
  fallback?: ReactNode;
}

/**
 * Gates the PM module behind the `PM-Module` PostHog feature flag (the live key — the flag
 * is not named after the constant that holds it, see FEATURE_FLAGS).
 *
 * Defaults to visible (`true`) so the module is always available when PostHog
 * is not configured or is still loading. Flip the flag to `false` in the
 * PostHog project to hide the module.
 */
export function PMModuleGate({ children, fallback = null }: PMModuleGateProps) {
  const isEnabled = useFeatureFlag(FEATURE_FLAGS.PM_MODULE_ENABLED, true);

  if (!isEnabled) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
